import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InfoData from '../InfoData';

const contacts = InfoData.contacts;

const MenuItem = ({ label, onClickItem }) => {
    return (
        <button onClick={onClickItem} className='py-[20px] md:p-0 text-center hover:text-primary'>{label}</button>
    );
};

const MenuButton = ({ showMobileMenu, toggleMboileMenu }) => {
    return (
        <div className='cursor-pointer w-fit z-10' onClick={toggleMboileMenu}>
            <div className={`w-[28px] h-[4px] bg-white my-1 duration-500 ` + (showMobileMenu ? 'translate-y-[11px] -rotate-45' : '')}></div>
            <div className={`w-[28px] h-[4px] bg-white my-1 duration-500 ` + (showMobileMenu ? 'opacity-0' : '')}></div>
            <div className={`w-[28px] h-[4px] bg-white my-1 duration-500 ` + (showMobileMenu ? '-translate-y-[5px] rotate-45' : '')}></div>
        </div>
    );
};

const ContactItem = ({icon, url, text, file}) => {
    if (!url && file) {
        url = require(`../${file}`);
    }
    return (
        <a href={url} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={icon} className="text-4xl"/>
        </a>
    );
}

const Header = ({ menuItems, showMobileMenu, toggleMboileMenu }) => {
    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 0) {
            document.querySelector('#header-container').classList.add('bg-base');
        } else {
            document.querySelector('#header-container').classList.remove('bg-base');
        }
    }

    useEffect(() => {
        // Set a event listener to detect the window scroll
        window.addEventListener('scroll', handleScroll);

        // Call the handleScroll function on page load
        handleScroll();

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    const clickMenuItem = (item) => {
        if (showMobileMenu) {
            toggleMboileMenu();
        }
        document.getElementById(item.elem).scrollIntoView({behavior: 'smooth'})
    }

    return (
        <div id="header-container" className='z-[1000] text-white w-full fixed top-0 right-0 px-[40px] py-[20px]'>
            <div className="hidden md:block">
                <div className='flex justify-end gap-6 cursor-pointer'>
                    {
                        menuItems.map((item, index) => (
                            <MenuItem key={index} label={item.label} onClickItem={() => clickMenuItem(item)} />
                        ))
                    }
                </div>
            </div>
            <div className="md:hidden">
                <div className="flex justify-end">
                    <MenuButton showMobileMenu={showMobileMenu} toggleMboileMenu={toggleMboileMenu} />
                </div>
                {
                    showMobileMenu && (
                        <div className='bg-base text-white fixed top-0 bottom-0 left-0 right-0'>
                            <div className='mt-[72px] flex flex-col divide-y border-y'>
                                {
                                    menuItems.map((item, index) => (
                                        <MenuItem key={index} label={item.label} onClickItem={() => clickMenuItem(item)} />
                                    ))
                                }
                            </div>
                            <div className="absolute bottom-[10%] flex justify-center items-center gap-6 w-full text-4xl">
                                {
                                    contacts.map((contact, index) => (
                                        <ContactItem key={index} {...contact}/>
                                    ))
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default Header;